module.exports = __webpack_public_path__ + "img/banner-fastvaluedeal.f91f4fb3.webp";